export enum EventName {
  googlePageView = 'page_view',
  metaPageView = 'PageView',
  wizardStep = 'wizard_step_',
  wizardSend = 'wizard_send',
  matchGenerated = 'match_generated',
  applicationLinkClick = 'click_bewerberlink',
  signUpStarted = 'signup_started',
  signUpVerified = 'signup_verified',
  login = 'login',
  appStoreClick = 'click_to_appstore',
  chatOpen = 'chat_open',
}

export enum EventValue {
  pageTitle = 'page_title',
  store = 'store',
}

export enum UserProperty {
  language = 'language',
}
